// extracted by mini-css-extract-plugin
export default {"toast":"Notifications_toast__7xAWo","appear":"Notifications_appear__LsvDv"};